var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourInternshipExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1001 -3102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-246 -1866)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1247 4968)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1010 3110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,19a6.957,6.957,0,0,1,7-7,7.05,7.05,0,0,1,6.1,3.5l1.7-1a8.834,8.834,0,0,0-4.2-3.7,6,6,0,1,0-7.2,0A8.9,8.9,0,0,0,0,19v5H12V22H2ZM5,6a4,4,0,1,1,4,4A4.012,4.012,0,0,1,5,6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1,15.8l-7.6,7.6-4.7-4.7,1.4-1.4,3.3,3.3,6.2-6.2Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourInternshipExperience);
export default __webpack_public_path__ + "static/media/your-internship-experience.ebcd0d2fdaf17e67c186b499be015fb9.svg";
export { ForwardRef as ReactComponent };